import { Component } from 'ng-metadata/core';
import './tray.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentTray
 * @module mw.components.contentDocuments
 *
 * @description
 * `mw-content-document-tray` is a component whose responsibility is to show any extra data relating to the content document cards
 * @usage
 * <hljs hljs-language="html">
 *  <mw-content-document-tray> <some-new-component></some-new-component> </mw-content-document-tray>
 * </hljs>
 */
@Component({
    selector: 'mw-content-document-tray',
    template: `
        <div class="mw-content-document-tray">
            <div class="mw-content-document-tray__content">
                <ng-transclude style="display:block;"></ng-transclude>
            </div>
        </div>
    `,
    legacy: {
        transclude: true
    }
})

export class TrayComponent {}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/shared/tray/tray.component.ts